/* eslint-disable unused-imports/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { ApplicationConstants } from '@ao/app/shared/constants/ApplicationConstants';
import { UrlEncoder } from '@ao/app/shared/utility/url-encoder';

@Injectable({ providedIn: 'root' })
export class WorkitemLinkGuard implements CanActivate {
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const dataParam = route.queryParams['data'];
    if (!dataParam) {
      return true;
    }

    try {
      const decoded = UrlEncoder.decode(dataParam);
      sessionStorage.setItem(
        ApplicationConstants.SessionKeyConstants.TenantId,
        JSON.stringify(decoded.tenantId)
      );
      sessionStorage.setItem(
        ApplicationConstants.SessionKeyConstants.LegalEntityId,
        JSON.stringify(decoded.entityId)
      );
      sessionStorage.setItem(
        ApplicationConstants.SessionKeyConstants.WorkspaceGuid,
        JSON.stringify(decoded.workspaceGuid)
      );
      sessionStorage.setItem(
        ApplicationConstants.SessionKeyConstants.WorkspaceItemGuid,
        JSON.stringify(decoded.workspaceItemGuid)
      );
      sessionStorage.setItem('isDeeplink', 'true');
    } catch {
      return false;
    }

    return true;
  }
}
